enum TableCellAlignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

export default TableCellAlignment;
